import React from 'react';

import { NavLink } from 'react-router-dom';

import {
  NEWS_URL,
  RESOURCES_URL,
  CASE_STUDIES_URL,
  UNISCORE_REPORT_URL,
  CHERRY_PICK_URL
} from 'global-constants';
import ExternalLink from 'shared/components/ExternalLink';

import styles from './styles.module.scss';

const ContentLibraryDropdown = () => (
  <div className={styles.wrapper}>
    <ExternalLink
      id="navigation-connect-videos"
      className={styles.item}
      href={UNISCORE_REPORT_URL}>
      UniScore Reports
    </ExternalLink>
    <ExternalLink
      id="navigation-cherry-pick"
      className={styles.item}
      href={CHERRY_PICK_URL}>
      Innovators in Real Estate
    </ExternalLink>
    <NavLink
      id="navigation-articles"
      className={styles.item}
      to={RESOURCES_URL}
      activeClassName={styles.selectedItem}>
      Articles
    </NavLink>
    <NavLink
      id="navigation-news"
      className={styles.item}
      to={NEWS_URL}
      activeClassName={styles.selectedItem}>
      News
    </NavLink>
    <NavLink
      id="navigation-case-studies"
      className={styles.item}
      to={CASE_STUDIES_URL}
      activeClassName={styles.selectedItem}>
      Case Studies
    </NavLink>
  </div>
);

export default ContentLibraryDropdown;
